import React from "react";
import { OrderHistoryProps } from "../types/dashboard";
import OrderSummary from "./OrderSummary";

const OrderHistory: React.FC<OrderHistoryProps> = ({ dashboardData = {}, businessType, }) => {
  const currentDate = new Date();
  const currentMonth = currentDate.toLocaleString("default", { month: "short" });
  const currentYear = currentDate.getFullYear();

  // Safely extract data
  const periodicDetails = dashboardData?.periodic_order_details || {};
  const monthlySummary = dashboardData?.calculate_monthly_summary || [];
  const orderCounts = dashboardData?.order_counts || {};

  // Today's data
  const todayOrders = periodicDetails?.today?.totalOrders || 0;
  const todaySales = periodicDetails?.today?.totalSales || 0;
  const todayOutstanding = periodicDetails?.today?.periodOutstanding || 0;
  const todayReceived = periodicDetails?.today?.totalReceived || 0;

  // Weekly data
  const weekOrders = periodicDetails?.weekly?.totalOrders || 0;
  const weekSales = periodicDetails?.weekly?.totalSales || 0;
  const weekOutstanding = periodicDetails?.weekly?.periodOutstanding || 0;
  const weekReceived = periodicDetails?.weekly?.totalReceived || 0;

  // Monthly data
  const ordersSummaryMonth = dashboardData?.orders_summary?.find((entry) => entry.month === currentMonth && entry.year === currentYear);
  const currentMonthSummary = monthlySummary.find((month) => month.month === currentMonth && month.year === currentYear);
  const monthOrders = orderCounts?.month || 0;
  const monthReceived = currentMonthSummary?.total_received || 0;
  const monthOutstanding = ordersSummaryMonth?.totalOutstandingBalance || 0;
  const monthSales = ordersSummaryMonth?.totalSales || 0;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-2 mb-3 w-full">
      <OrderSummary title="Today's Orders" timeRange="today" orders={todayOrders} amount={todaySales} received={todayReceived} outstanding={todayOutstanding} businessType={businessType} />
      <OrderSummary title="Last 7 Days Orders" timeRange="week" orders={weekOrders} amount={weekSales} received={weekReceived} outstanding={weekOutstanding} businessType={businessType} />
      <OrderSummary title="This Month's Orders" timeRange="month" orders={monthOrders} amount={monthSales} received={monthReceived} outstanding={monthOutstanding} businessType={businessType} />
    </div>
  );
};

export default OrderHistory;